import { useState, useEffect } from 'react';

type DebounceOptionsType = {
	resetBeforeSettingValue?: boolean;
};

const useDebounce = (
	value: any,
	delay: number,
	options?: DebounceOptionsType,
) => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		if (options?.resetBeforeSettingValue) {
			setDebouncedValue(''); // Reset before setting the new value
		}
		const handler = setTimeout(() => {
			if (typeof value === 'string') {
				setDebouncedValue(value.trim());
			} else {
				setDebouncedValue(value);
			}
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay, options?.resetBeforeSettingValue]);

	return debouncedValue;
};

export default useDebounce;
